import './CensusReview.scss'
import React, { useMemo, useState } from 'react'
import { Layout } from '@surecompanies/core_components'
import Page from 'layouts/Page'
import { ENVIROMENT_DEV, getEnvironment } from 'modules/app-config/environment'
import PageWrapper from '../../../../PageWrapper'
import { useCensusV2Clients } from '../../hooks/use-census-v2-clients'
import NewAndUpdatedRecords from '../components/NewAndUpdatedRecords'
import ActivityHistory from '../components/ActivityHistory'
import BreadcrumbNav from '../../../../components/Breadcrumbs'
import { withRouter } from 'react-router'
import { message } from 'antd'
import { CensusClientFilter } from '../../types/census-client-filter'
import { filterClients } from '../utils/filter-clients'
import CensusReviewDataFilter from '../components/CensusReviewDataFilter'

const { Content } = Layout

function CensusReview() {
  const [filter, setFilter] = useState<CensusClientFilter>({
    includeTestCompanies: getEnvironment() === ENVIROMENT_DEV,
  })
  const { clients, error } = useCensusV2Clients()

  if (error) {
    const msg = `Error loading companies: ${error.message}`
    console.error(msg)
    message.error(msg, 5)
  }

  const handleFilterChange = (value: CensusClientFilter) => {
    filterClients(clients, value).map((client) => client.id)
    setFilter(value)
  }

  const clientNameLookup = useMemo(() => {
    return clients.reduce((acc, client) => {
      acc[client.id] = client.name
      return acc
    }, {})
  }, [clients])

  return (
    <PageWrapper>
      <Page
        title="Census Review"
        horizontalRule={true}
        action={
          <CensusReviewDataFilter
            filter={filter}
            onFilterChange={handleFilterChange}
          />
        }
        breadcrumb={<BreadcrumbNav items={[{ title: 'Census Review' }]} />}
      >
        <Layout style={{ backgroundColor: '#f6f9fc' }}>
          <Content style={{}}>
            <NewAndUpdatedRecords
              clientNameLookup={clientNameLookup}
              filter={filter}
            />
            <ActivityHistory
              clientNameLookup={clientNameLookup}
              filter={filter}
            />
          </Content>
        </Layout>
      </Page>
    </PageWrapper>
  )
}

export default withRouter(CensusReview)
